import { status as PS } from '../../helpers/passport';
import { isAdmin, isProjectAdmin, isPolicyAdmin } from '../rolesSvc';

/**
 * Правила ТОЛЬКО для проектов портфелей политик, у которых НЕТ привязки к СП
 * @type {{Delete: {isRoleOk: (function(*, *, *): *), isStatusOk: (function(*): boolean)}, ExpertsApprove: {isRoleOk: (function(*, *, *): *), isStatusOk: (function(*): boolean)}, ApproveFinal: {isAnyVersion: boolean, isRoleOk: (function(*, *, *): *), isStatusOk: (function(*): boolean)}, SendToCommittee: {isRoleOk: (function(*, *, *): *), isStatusOk: (function(*): boolean)}, ExpertsReturn: {isRoleOk: (function(*, *, *): *), isStatusOk: (function(*): boolean)}, ExpertsDecline: {isRoleOk: (function(*, *, *): *), isStatusOk: (function(*): boolean)}, Edit: {extra: (function(*, *, *, *, *): *), isRoleOk: (function(*, *, *): *), isStatusOk: (function(*): boolean)}, EditCurrent: {isAnyStatus: boolean, isRoleOk: (function(*, *, *): *), isStatusOk: (function(*): boolean)}}}
 */
const rules = {
  Delete: {
    isStatusOk: (status) => [PS.draft, PS.returnedByCommittee].includes(status),
    isRoleOk: (userCtx, policyId, projId) => isProjectAdmin(userCtx, projId) || isAdmin(userCtx),
  },
  Edit: {
    isStatusOk: (status) => status !== PS.committeeApproved,
    isRoleOk: (userCtx, policyId, projId) => isProjectAdmin(userCtx, projId) || isAdmin(userCtx),
    extra: (status, userCtx, stratId, projId, portfId) => isAdmin(userCtx)
        || isProjectAdmin(userCtx, projId) && [PS.draft, PS.returnedByCommittee, PS.approved].includes(status),
    // РП может редактировать на своих статусах и создавать новые версии
  },
  EditCurrent: {
    isAnyVersion: true,
    isStatusOk: (status) => [PS.approved, PS.committeeApproved].includes(status),
    isRoleOk: (userCtx, policyId, projId) => isAdmin(userCtx),
  },
  EditCurrentMilestones: {
    isStatusOk: (status) => [PS.approved, PS.committeeApproved].includes(status),
    isRoleOk: (userCtx, policyId, projId) => isProjectAdmin(userCtx, projId) || isAdmin(userCtx),
  },
  SendToCommittee: {
    isStatusOk: (status) => [PS.draft, PS.returnedByCommittee].includes(status),
    isRoleOk: (userCtx, policyId, projId) => isProjectAdmin(userCtx, projId) || isAdmin(userCtx),
  },
  ExpertsReturn: {
    isStatusOk: (status) => [PS.onApproveCommittee].includes(status),
    isRoleOk: (userCtx, policyId, projId) => isAdmin(userCtx),
  },
  ExpertsApprove: {
    isStatusOk: (status) => [PS.onApproveCommittee].includes(status),
    isRoleOk: (userCtx, policyId, projId) => isAdmin(userCtx),
  },
  ExpertsDecline: {
    isStatusOk: (status) => [PS.onApproveCommittee].includes(status),
    isRoleOk: (userCtx, policyId, projId) => isAdmin(userCtx),
  },
  ApproveFinal: {
    isAnyVersion: true,
    isStatusOk: (status) => [PS.committeeApproved, PS.expertsApproved, PS.approved, PS.closed, PS.moved].includes(status),
    isRoleOk: (userCtx, policyId, projId) => isProjectAdmin(userCtx, projId) || isPolicyAdmin(userCtx, policyId) || isAdmin(userCtx),
  },
  MoveProject: {
    isStatusOk: (status) => ![PS.closed, PS.moved].includes(status),
    isRoleOk: (userCtx) => isAdmin(userCtx),
  },
};

export const getActionsModel = (status, userCtx, policyId, projId, isLatestVersion) => Object.entries(rules).reduce((acc, [key, rule]) => ({
  ...acc,
  [key]: (isLatestVersion || rule.isAnyVersion)
    && rule.isStatusOk(status)
    && rule.isRoleOk(userCtx, policyId, projId)
    && (!rule.extra || rule.extra(status, userCtx, policyId, projId)),
}), {});
